import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { BundleType, EntityTypeId, FieldName, ImageModel } from '../../../common/models';
import { LibraryItem } from '../../models';
import { FileExtensionService } from '../../services/file-extension/file-extension.service';
import { BaseSettingsGetService } from '../../../common/services';
import { SETTINGS_SERVICE } from '../../../common/constants';

@Component({
    selector: 'lib-library-details-sidebar',
    templateUrl: './library-details-sidebar.component.html',
    styleUrls: ['./library-details-sidebar.component.scss'],
    standalone: false
})
export class LibraryDetailsSidebarComponent implements OnInit {
  @Input() allowDownload: boolean;

  @Input() public set libraryItem(value: LibraryItem) {
    this._libraryItem = value;

    if (value) {
      this.previewImage = this.fileExtensionService.getLibraryItemPreviewImage(value);

      this.fieldName = value.mediaImage ? FieldName.MEDIA_IMAGE : FieldName.AWS_FILE;
    }
  }

  public get libraryItem() {
    return this._libraryItem;
  }

  @Output() public download: EventEmitter<LibraryItem> = new EventEmitter();
  @Output() public preview: EventEmitter<LibraryItem> = new EventEmitter();
  @Output() public closed: EventEmitter<void> = new EventEmitter();

  public previewImage: ImageModel;
  public hideUpdatedDate = false;
  public hideCreatedDate = false;

  public readonly entityTypeId: typeof EntityTypeId = EntityTypeId;
  public readonly bundleType: typeof BundleType = BundleType;
  public fieldName: FieldName = FieldName.AWS_FILE;

  private _libraryItem: LibraryItem;

  constructor(
    @Inject(SETTINGS_SERVICE) private readonly settingsService: BaseSettingsGetService,
    private readonly fileExtensionService: FileExtensionService,
    private readonly element: ElementRef) { }

  ngOnInit(): void {
    const rect = this.element.nativeElement.getBoundingClientRect();
    const scrollTop = window.scrollY || window.pageYOffset;
    this.element.nativeElement.style.setProperty('--lib-library-sidebar-top', `${rect.top + scrollTop}px`);
    this.settingsService.getSettings().subscribe(settings => {
      this.hideUpdatedDate = settings.library?.removeUpdatedDateFromCard;
      this.hideCreatedDate = settings.library?.removeCreatedDate;
    })
  }

  public close(): void {
    this.libraryItem = null;
    this.closed.emit();
  }

}
